let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("84p2v")).then(() => parcelRequire('7S5uT'));